import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VCard,{staticClass:"d-flex flex-column"},[_c(VCardTitle,{staticClass:"font-weight-semibold"},[_vm._v(" "+_vm._s(_vm.statistics)+" ")]),_c('vue-apex-charts',{attrs:{"options":_vm.chartOptionsComputed,"series":_vm.chartSeries,"height":_vm.chartHeight}}),_c(VCardText,{staticClass:"font-weight-semibold text-center text--primary"},[_vm._v(" "+_vm._s(_vm.statTitle)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }